import { useCallback } from "react";

import { getOrderUrl, getTestResultsUrl } from "@/core/urls";
import { useQuery } from "@apollo/client";

import { REPORTS_LIST_QUERY } from "../reports/graphql/queries";

export default function useCustomerTestsAndReports() {
  const getReportUrl = useCallback(report => `/reports/${report.slug}/overview`, []);

  const { data: reportsData } = useQuery(REPORTS_LIST_QUERY, {
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first"
  });

  return {
    getOrderUrl,
    getTestResultUrl: getTestResultsUrl,
    getReportUrl,
    reports: reportsData?.reports,
    userReports: reportsData?.userReports,
    reportViewType: "customer"
  };
}
